import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import config from './keys.js'

const firebaseConfig = config
let maskPath = 'masks'
let reservationPath = 'reservations'
let faqsPath = 'faqs'
let systemRefPath = 'system'

if (window.location.host.includes('dev')) {
  maskPath = 'masksdev'
  reservationPath = 'reservationsdev'
  systemRefPath = 'systemdev'
}
let fb = firebase.initializeApp(firebaseConfig)
let fire = firebase
const db = firebase.firestore()

// Initialize your Web app as described in the Get started for Web
// firebaseApp previously initialized using firebase.initializeApp().
// if (location.hostname === "devlocal.oro.gg") {
//   db.settings({
//     host: "localhost:8081",
//     ssl: false
//   });
// }

const auth = fb.auth()
const masksRef = db.collection(maskPath)
const reservationsRef = db.collection(reservationPath)
const faqsRef = db.collection(faqsPath)
const systemRef = db.collection(systemRefPath)
const storage = firebase.storage()
export {
  db,
  fire,
  auth,
  masksRef,
  reservationsRef,
  systemRef,
  storage,
  faqsRef
}
